"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7617 4.00945C11.4161 3.38912 9.90084 3.23988 8.46008 3.58577C7.01932 3.93167 5.73697 4.75255 4.81966 5.91615C3.90235 7.07976 3.40351 8.5183 3.40351 10C3.40351 10.3876 3.08932 10.7018 2.70175 10.7018C2.31419 10.7018 2 10.3876 2 10C2 8.20305 2.60498 6.45843 3.71747 5.04725C4.82995 3.63607 6.38514 2.64053 8.13244 2.22105C9.87974 1.80156 11.7174 1.98255 13.3493 2.73486C14.9812 3.48718 16.3123 4.76699 17.128 6.36809C17.9438 7.96919 18.1968 9.79831 17.8463 11.5607C17.4957 13.3232 16.562 14.9162 15.1956 16.0833C13.8291 17.2503 12.1096 17.9233 10.3141 17.9938C9.28464 18.0343 8.2646 17.8753 7.30762 17.5333C6.94266 17.4029 6.75254 17.0013 6.88297 16.6363C7.0134 16.2714 7.41499 16.0813 7.77996 16.2117C8.56908 16.4937 9.41015 16.6248 10.259 16.5914C11.7395 16.5332 13.1574 15.9783 14.2841 15.016C15.4108 14.0537 16.1807 12.7401 16.4697 11.2869C16.7588 9.8337 16.5502 8.32547 15.8775 7.00527C15.2048 5.68506 14.1073 4.62978 12.7617 4.00945Z",
    fill: "#727B7F"
  }));
};